import { privateAxios } from '@/services/api'

export const _getMedia = (data, tab) => {
    return privateAxios.post(`/media/search/${tab}`, data)
        .then(response => response.data)
}

export const _deleteMedia = (id) => {
    return privateAxios.delete(`/media/${id}`)
        .then(response => response.data)
}

export const _updateMedia = (data) => {
    return privateAxios.put(`/media`, data)
        .then(response => response.data)
}

export const _updateUsedMedia = (uuid, data) => {
    return privateAxios.put(`/media/used/${uuid}`, data)
        .then(response => response.data)
}
